import Collection from '../../utils/Collection';

import {
  BOOK_SENT,
  BOOK_SUCCEEDED,
  BOOK_FAILED,
  CANCEL_BOOKING_SENT,
  CANCEL_BOOKING_SUCCEEDED,
  CANCEL_BOOKING_FAILED,
  CANCEL_BOOKING_BY_TUTOR_SENT,
  CANCEL_BOOKING_BY_TUTOR_SUCCEEDED,
  CANCEL_BOOKING_BY_TUTOR_FAILED,
  FETCH_MY_BOOKINGS_SENT,
  FETCH_MY_BOOKINGS_SUCCEEDED,
  FETCH_MY_BOOKINGS_FAILED,
  FETCH_MY_BOOKING_SENT,
  FETCH_MY_BOOKING_SUCCEEDED,
  FETCH_MY_BOOKING_FAILED,
} from '../../actions/booking';

import { FETCH_TIMESLOT_STATUSES_BY_TUTOR_SUCCEEDED } from '../../actions/timeslot';

const initialState = {
  myBookings: [],
  myBookingsUpdatedAt: null,
  numOfMyBookings: 0,
  page: 1,
  loading: false,
  loadingOne: false,
  loadedOnce: false,
  saving: false,
};

export default function bookingReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case BOOK_SUCCEEDED:
      return {
        ...state,
        saving: false,
        myBookings: Collection.add(state.myBookings, payload.booking),
        numOfMyBookings: state.numOfMyBookings + 1,
        myBookingsUpdatedAt: new Date(),
      };
    case CANCEL_BOOKING_SUCCEEDED:
      if (payload.bookings) {
        // This is for when cancel from the dashboard.
        return {
          ...state,
          saving: false,
          myBookings: Collection.reset(state.myBookings, payload.bookings),
          numOfMyBookings: state.numOfMyBookings - 1,
          myBookingsUpdatedAt: new Date(),
        };
      } else {
        return {
          ...state,
          saving: false,
          myBookings: Collection.remove(
            state.myBookings,
            payload.deletedBooking,
          ),
          numOfMyBookings: state.numOfMyBookings - 1,
        };
      }
    case CANCEL_BOOKING_BY_TUTOR_SUCCEEDED:
      return {
        ...state,
        saving: false,
        myBookings: Collection.remove(state.myBookings, payload.lesson),
        numOfMyBookings: state.numOfMyBookings - 1,
        myBookingsUpdatedAt: new Date(),
      };
    case FETCH_TIMESLOT_STATUSES_BY_TUTOR_SUCCEEDED:
      return {
        ...state,
        myBookings: Collection.reset(
          state.myBookings,
          payload.student_bookings,
        ),
      };
    case FETCH_MY_BOOKINGS_SUCCEEDED:
      return {
        ...state,
        saving: false,
        myBookings: Collection.reset(state.myBookings, payload.bookings),
        numOfMyBookings: payload.numOfBookings,
        loadedOnce: true,
        loading: false,
      };
    case FETCH_MY_BOOKINGS_SENT:
      return {
        ...state,
        loading: true,
        page: payload.page,
      };
    case FETCH_MY_BOOKINGS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case FETCH_MY_BOOKING_SENT:
      return {
        ...state,
        loadingOne: true,
      };
    case FETCH_MY_BOOKING_SUCCEEDED:
      return {
        ...state,
        loadingOne: false,
        myBookings: Collection.removeAndAdd(state.myBookings, payload.booking),
      };
    case FETCH_MY_BOOKING_FAILED:
      return {
        ...state,
        loadingOne: true,
      };
    case BOOK_SENT:
    case CANCEL_BOOKING_SENT:
    case CANCEL_BOOKING_BY_TUTOR_SENT:
      return {
        ...state,
        saving: true,
      };
    case BOOK_FAILED:
    case CANCEL_BOOKING_FAILED:
    case CANCEL_BOOKING_BY_TUTOR_FAILED:
      return {
        ...state,
        saving: false,
      };
    default:
      return state;
  }
}
